
<div id="left-search-bar" class="leftSearchBar" #parent [@state]="state">
  <div id="left-drag-bar" class="left-drag-bar" appResize [parent]="parent" left-to-right (sizeChange)="sizeChange($event)"></div>
  <div class="findBar">
    <div class="findBar-title"> {{ isSearch ? 'Find' : 'Find & Replace' }}</div>
    <div class="findBar-settings">
      <div class="icon icon_settings" [formGroup]="settingsForm">
        <mat-select panelClass="findPanel"
          disableOptionCentering
          class="search-bar"
          style="background: url('../../../../../assets/svg/redesign/settings.svg') center center no-repeat; height: 20px;"
          formControlName="settings" multiple (selectionChange)="settingsChange($event.value)">

          @for (group of groups; track group; let last = $last) {
            @if (!(group === 'settings' && !isSearch)) {
              <mat-optgroup class="hideLabel">
                @for (option of findAndReplaceOptions[group]; track option) {
                  <mat-option [value]="option.value" [disabled]="option.value === 'findAndReplace' && !canReplace"
                    (onSelectionChange)="optionClicked($event)"> {{ option.display }}
                  </mat-option>
                }
              </mat-optgroup>
              @if (!last) {
                <mat-divider></mat-divider>
              }
            }
          }
        </mat-select>
      </div>
      <div class="icon icon_close" (click)="close()"></div>
    </div>
  </div>

  <div class="search-container">

    <input #searchInput id="Search" type="search" class="searchBtn" placeholder="Find..." autocomplete="off"/>
    <ng-container *ngTemplateOutlet="searchReplace"></ng-container>

    @if (settingsForm.controls['settings'].value | settingsDisplay; as settingsToDisplay) {
      <div class="searchSettings"
        >
        @for (display of settingsToDisplay; track display) {
          <div class="searchSettings-options">
            + {{ display }}
          </div>
        }
      </div>
    }

  </div>


  @if (found && !isLoading) {
    <div class="results">
      @if (!found.error) {
        @if (found.length) {
          <ng-container *ngTemplateOutlet="displayFound"></ng-container>
        } @else {
          <div class="errorMessage">
            No results found
          </div>
        }
      } @else {
        <div class="errorMessage">
          {{ found.error }}
        </div>
      }
    </div>
  } @else {
    <div class="loading">
      @if (isLoading) {
        <loading-icon></loading-icon>
      }
    </div>
  }
</div>

<ng-template #searchReplace>
  @if (!isSearch) {
    <div>
      <input #replaceInput class="replace highlight" placeholder="Replace with..."/>
      <button (click)="replace(replaceInput.value)"
        [disabled]="found === undefined || found?.length === 0 || found?.error || selected === undefined"> Replace
      </button>
    </div>
  }
</ng-template>


<ng-template #displayFound>


  <div class="found-count">
    <div>
      {{ found | resultCount }} Results
    </div>

    <div class="next-item">
      <img height="20px" src="../../../../../assets/svg/redesign/up-arrow.svg" (click)="previousItem()">
      <img height="20px" src="../../../../../assets/svg/redesign/down-arrow.svg" (click)="nextItem()">
    </div>
  </div>


  <div class="found-container">
    @for (founded of found; track founded; let foundIndex = $index) {
      <div>
        <div class="found-container-header" (click)="onClick(founded)">
          <img [src]="founded.nodeType | nodeIcon:currentNodeType">
          <div>
            {{ founded.stepId | stepNumber }}
          </div>
        </div>
        @for (match of founded.matched; track match; let matchIndex = $index) {
          <div id="match-{{foundIndex}}-{{matchIndex}}" class="found-container-match"
            (click)="onClick(founded, match, foundIndex, matchIndex)" [innerHTML]="match.highlight | wordEclipse:parent.style.width">
          </div>
        }
      </div>
    }
  </div>

</ng-template>